module.exports = __webpack_public_path__ + "saira-semibold-webfont.406ba73054c362d9e8e8.ttf";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/assets/fonts/saira-semibold-webfont.ttf
// module id = ../../../../../src/assets/fonts/saira-semibold-webfont.ttf
// module chunks = styles